import { cn } from "design/lib"
import type { ComponentProps } from "react"
import type { SparkColour } from "../../lib"
import Dot from "../spark/Dot"

type Props = ComponentProps<"label"> & {
  spark?: SparkColour
}

function Label({ className, children, spark, ...props }: Props) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {spark && <Dot spark={spark} />}
      {children}
    </label>
  )
}

export { Label }
